

import React, { useState } from "react";
import { motion } from "framer-motion";
import PersonImage from "../../../images/aaaservices/VIKAS_STUDENT_PIC[1].png"; // Update the path
import QRImage from "../../../images/qr-code.png"; // Add your QR code image

const Appinformation = () => {
  const [showPopup, setShowPopup] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  return (
    <>
      <style>{`
        .containerss {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          padding: 50px;
          font-family: Arial, sans-serif;
          height: auto;
          margin: auto;
          background-color:#2a0947;
          overflow: hidden;
          flex-wrap: wrap;
          margin-top: 30px;
        }

        .text-sectiony {
          max-width: 50%;
          text-align: left;
        }

        .image-sectiony {
          display: flex;
          justify-content: flex-start;
          width: 50%;
        }

        .imagess {
          width: 100%;
          max-width: 681px;
          border-radius: 10px;
        }

        .headingyss {
          font-size: 50px;
          font-weight: bold;
          color: white;
        }

        .bold {
          color: #ffe124;
        }

        .highlighted {
          color: white;
          border-bottom: 3px solid #ffe124;
          display: inline-block;
        }

        .paragraph {
          font-size: 17px;
          color: white;
          margin: 10px 0 20px;
        }

        .buttonContainer {
          margin-top: 20px;
        }

        .downloadBtn {
          background-color: #ffe124;
          color: #2a0947;
          padding: 12px 25px;
          font-size: 20px;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          transition: 0.3s ease;
          font-weight: bold;
        }

        .popupOverlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }

        .popupInner {
          background: white;
          padding: 30px;
          border-radius: 10px;
          text-align: center;
          position: relative;
          max-width: 400px;
          animation: slideUp 0.4s ease;
        }

        .closeBtn {
          position: absolute;
          top: 10px;
          right: 15px;
          font-size: 20px;
          background: none;
          border: none;
          cursor: pointer;
        }

        .scannerImg {
          width: 200px;
          height: auto;
          margin-bottom: 15px;
        }

        @media (max-width: 768px) {
          .containerss {
            flex-direction: column-reverse;
            height: auto;
          }

          .text-sectiony,
          .image-sectiony {
            max-width: 100%;
            width: 100%;
            text-align: center;
            justify-content: center;
          }

          .headingyss {
            font-size: 36px;
          }

          .imagess {
            max-width: 90%;
            margin: 0 auto;
          }
        }

        @media (max-width: 480px) {
          .headingyss {
            font-size: 30px;
          }

          .paragraph {
            font-size: 14px;
          }

          .downloadBtn {
            font-size: 16px;
            padding: 10px 20px;
          }

          .scannerImg {
            width: 150px;
          }
        }
      `}</style>

      <div className="containerss">
        {/* Image Section - LEFT */}


        {/* Text Section - RIGHT */}
        <motion.div
          className="text-sectiony"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <p className="headingyss">
            VENDOR <span className="bold">DASHBOARD –Your </span> <br />
            {/* <span className="bold"></span>  <br /> */}
            <span className="highlighted"> Command Center</span>
          </p>

          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "10px", color: "white" }}>
              <strong style={{ color: "gold" }}>🏠 Dashboard</strong>Manage orders, inventory, and promotions ———— all in one place.
            </li>
            <li style={{ marginBottom: "10px", color: "white" }}>
              <strong style={{ color: "gold" }}>🛒 Orders</strong>Track incoming orders, update status, and view complete order history.
            </li>
            <li style={{ marginBottom: "10px", color: "white" }}>
              <strong style={{ color: "gold" }}>📦 Inventory</strong>Monitor stock levels, add new items, and update availability in real-time.
            </li>
            <li style={{ marginBottom: "10px", color: "white" }}>
              <strong style={{ color: "gold" }}>💬 Support</strong>Chat with support, raise issues, or request technical help — anytime.
            </li>
            <li style={{ marginBottom: "10px", color: "white" }}>
              <strong style={{ color: "gold" }}>📊 Reports</strong>Get insights on sales, earnings, and customer behavior — daily or monthly
            </li>
            <li style={{ marginBottom: "10px", color: "white" }}>
              <strong style={{ color: "gold" }}>🧾 Billing</strong>View transactions, download invoices, and track payments received.
            </li>
            <li style={{ marginBottom: "10px", color: "white" }}>
              <strong style={{ color: "gold" }}>👤 Profile</strong>Update store details, working hours, delivery radius, and bank info.
            </li>
          </ul>


          <div className="buttonContainer">
            <button className="downloadBtn" onClick={togglePopup}>
              Download App
            </button>
          </div>

          {showPopup && (
            <div className="popupOverlay">
              <div className="popupInner">
                <button className="closeBtn" onClick={togglePopup}>
                  ×
                </button>
                <img src={QRImage} alt="QR Code Scanner" className="scannerImg" />
                <p>Scan the QR code to download the Maamaas App!</p>
              </div>
            </div>
          )}
        </motion.div>

        <motion.div
          className="image-sectiony"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <img src={PersonImage} alt="Person" className="imagess" />
        </motion.div>

      </div>
    </>
  );
};

export default Appinformation;
